require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2010-10-12-java-trap-2010-edition.json") })
        }
      }, "path---articles-2010-10-12-java-trap-2010-edition");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2010-10-12-java-trap-2010-edition!./.cache/json/articles-2010-10-12-java-trap-2010-edition.json
// module id = 600
// module chunks = 231608221292675